import PropTypes from 'prop-types';
import React from 'react';
import RequiredIcon from 'components/connectedForm/RequiredIcon';
import styled from 'styled-components';
import { p4Tokens } from '../../styles/themes/default/p4FluentTheme';

const CardLabelBlock = styled.div`
  width: 100%;
  text-align: ${(props) => (props.align ? props.align : 'right')};
  text-transform: uppercase;
  line-height: 11px;
`;

const CardHeading = styled.label`
  display: inline-block;
  width: 100%;
  margin: 0;
  font-size: 10px;
  font-weight: 400;
  cursor: ${(props) => (props.disabled ? 'not-allowed ' : props.clickable ? 'pointer' : null)};
  color: ${(props) => (props.clickable ? p4Tokens.fieldLink : p4Tokens.colorNeutralForeground4)};
`;

const CardLabel = (props) => {
  const { includeLabel, label, mandatory, readOnly, clickable, fontStyle = {} } = props;
  if (!includeLabel) {
    return null;
  }

  return (
    <CardLabelBlock {...props}>
      <CardHeading clickable={clickable} style={fontStyle}>
        {label}
        <RequiredIcon mandatory={mandatory} readOnly={readOnly} />
      </CardHeading>
    </CardLabelBlock>
  );
};

CardLabel.propTypes = {
  flexBox: PropTypes.bool,
  hint: PropTypes.string,
  id: PropTypes.string,
  includeLabel: PropTypes.bool,
  label: PropTypes.string,
  cols: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  mandatory: PropTypes.bool,
  readOnly: PropTypes.bool,
  styleName: PropTypes.string,
};
CardLabel.defaultProps = {
  flexBox: true,
  hint: '',
  id: '',
  includeLabel: true,
  label: '',
  cols: 1 / 4,
  mandatory: false,
  readOnly: false,
  styleName: 'onLabelCol',
};

export default CardLabel;
